<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="缺货分布" name="distribution"></el-tab-pane>
      <el-tab-pane :label="`缺货订单(${data.stockOutOrderNum ||''})`" name="orders">
        <template slot="label">
          <el-tooltip effect="light">
            <el-button slot="content" type="text">缺货订单：统计以订单为维度的数量</el-button>
            <el-button type="text">{{`缺货订单(${data.stockOutOrderNum ||''})`}}</el-button>
          </el-tooltip>
        </template>
      </el-tab-pane>
      <el-tab-pane :label="`不缺货订单(${data.unStockOutOrderNum ||''})`" name="nonStockOrders"></el-tab-pane>
      <el-tab-pane :label="`缺货产品(${data.stockOutProductNum ||''})`" name="products"></el-tab-pane>
      <el-tab-pane :label="`缺货包件(${data.stockOutPackNum ||''})`" name="packages"></el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'name',
    event: 'update'
  },
  props: {
    name: {
      type: String,
      default: 'distribution'
    }
  },
  data() {
    return {
      activeName: '',
      total: {},
      data: {}
    }
  },
  watch: {
    name: {
      handler(val) {
        this.activeName = val
      },
      immediate: true
    }
  },
  mounted() {
    // this.getTbasNum();
    this.$bus.$on('tabNum', (data)=>{
     this.data = data
  });
  },
  methods: {
    handleClick(tab) {
      this.$emit('update', tab.name)
      this.$emit('handleTabClick', true)
    },
    // async getTbasNum() {
    //   let data = {
    //     pageNum: 1,
    //     pageSize: 1,
    //     filterData: {
    //       outStockOrder: true
    //     }
    //   }
    //   let res1 = await this.$q.orderDate.deliveryOrderList({data: data})
    //   let res2 = await this.$q.orderDate.deliveryOutOfStockProducts({data: data})
    //   let res3 = await this.$q.orderDate.deliveryShortagePackListPage({data: data})
      
    //   this.total = [res1.data.total, res2.data.total, res3.data.dynamicData.total]
    // }
  }
}
</script>

<style>

</style>
